import React, { Component } from 'react';

import './Home.scss';

import {
	ParallaxScene,
	AnimatedLayer,
	TimelineItem,
	TimelineButton,
	ListItem
} from '../../components/';

import { TimelineMax } from 'gsap';
import { TweenMax } from 'gsap';
import { Helmet } from "react-helmet";

import Swipeable from 'react-swipeable';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images
} from '../../settings/';

class Home extends Component {

	constructor(props) {
		super(props);

        this.state = {
            indicators: 'nav_indicator nav_indicator--1',
            scrolling: true,
            width: window.innerWidth,
            steps: (window.innerWidth <= 769) ? 10 : 3,
            step: 0,
            timelineStep: 'timeline-step-0',
            maskFirst: '',
            timelineItemsDisplayed: '',
            navItemActive: [
            	'',
            	'',
            	'',
            	'',
            	'',
            	'',
            	'',
            	'',
            	'',
            	'',
            	'',
            	'',
            	''
            ]
        };

		this.images = images;
		this.vector_on;
		this.vector_off;
		this.setVectors();

        this.timelineFill;
        this.timelineFinished;

        this.changeTimelineStep = this.changeTimelineStep.bind(this);
        this.nextItem = this.nextItem.bind(this);
        this.prevItem = this.prevItem.bind(this);
        this.bulletsAnimation = this.bulletsAnimation.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.animate = this.animate.bind(this);
        this.setNavItemActive = this.setNavItemActive.bind(this);
        this.runTransition = this.runTransition.bind(this);
        this.openTimelinebutton = this.openTimelinebutton.bind(this);
	}

	handleScroll(e) {
        const { width } = this.state;
        const isMobile = width <= 769;

		if (!this.state.scrolling && !isMobile) {
    		this.setState({ scrolling : true });
			
			var target = ( e.deltaY < 0) ? 'up' : 'down';

			this.animate(target);
		}
	}

	nextItem() {
        const { width } = this.state;
        const isMobile = width <= 769;

		if (!this.state.scrolling && isMobile) {
	    	this.animate('down');
	    }
	}

	prevItem() {
        const { width } = this.state;
        const isMobile = width <= 769;

		if (!this.state.scrolling && isMobile) {
	    	this.animate('up');
	    }
	}

	setVectors() {
        const { width } = this.state;
        const isMobile = width <= 769;

        this.vector_off = (isMobile) ? this.images.vector_off_mobile : this.images.vector_off;
        this.vector_on = (isMobile) ? this.images.vector_on_mobile : this.images.vector_on;
	}

	bulletsAnimation() {
		console.log('bulletsAnimation');
		[].slice.call(document.querySelectorAll('.nav')).forEach(function(nav) {
			var navItems = [].slice.call(nav.querySelectorAll('.nav__item')),
				itemsTotal = navItems.length,
				setCurrent = function(item) {
					// return if already current
					if( item.classList.contains('nav__item--current') ) {
						return false;
					}
					// remove current
					var currentItem = nav.querySelector('.nav__item--current');
					currentItem.classList.remove('nav__item--current');
					
					// set current
					item.classList.add('nav__item--current');
				};
			
			navItems.forEach(function(item) {
				item.addEventListener('click', function() { setCurrent(item); });
			});
		});
	}

	openTimelinebutton(url) {
		// console.log(url);
	}

	changeTimelineStep(step) {
		if (this.state.step != step) {
			this.setState({
				step : step,
				timelineStep : 'timeline-step-' + step
			});
		}
	}

	animate(target) {
        const { width } = this.state;
        let nextStep;

		if (target == 'down') {
			nextStep = this.state.step + 1;

			if (nextStep < this.state.steps) {
				this.changeTimelineStep(nextStep);

			} else if (nextStep == this.state.steps) {
				this.changeTimelineStep(0);
			}
		}

		if (target == 'up') {
			nextStep = this.state.step - 1;

			if (nextStep >= 0) {
				this.changeTimelineStep(nextStep);
			}
		}

		setTimeout(function() {
			this.setState({ scrolling : false });
		}.bind(this), 1350);
	}

    mobileSwipe(e, x, y, isFlick, velocity) {
        const { width } = this.state;
        const isMobile = width <= 769;

		if (!this.state.scrolling && !this.state.homeServiceOpened && isMobile) {
    		// if (y < (-40) && y < 20) {
    		// 	console.log('menor que -40');
    			this.setState({ scrolling : true });

	        	if (x > 0) {
	        		// Next
	        		this.animate('down');
	        	} else {
	        		// Prev
	        		this.animate('up');
	        	}
    		// }
        }
    }

    setNavItemActive(num) {
		let items = this.state.navItemActive;
		let index = items.findIndex(obj => obj == 'opened');

		// Zera o array
		items.forEach((el, i) => items[i] = '');

		if (index != num) {
			// Seta o ativo
			items[num] = 'opened';
		}

		// Salva no State
		this.setState({ navItemActive : items });
    }

    runTransition() {
    	Actions.globalTransition();
    }

	componentDidMount() {
        const { width } = this.state;
        const isMobile = width <= 769;

    	Actions.menuHome();
    	Actions.logoHome();
    	Actions.hideFooter();

		// console.log('home mount');
	    window.addEventListener('wheel', this.handleScroll);

	    this.bulletsAnimation();

	    this.timelineFill = setTimeout(() => this.setState({ maskFirst : 'mask_on--first' }), 1000);
	    this.timelineFinished = setTimeout(() => this.setState({ scrolling : false, timelineItemsDisplayed : 'displayed' }), (isMobile) ? 2500 : 3500);
	}


	componentWillUnmount() {
		// console.log('home unmount');
	    window.removeEventListener('wheel', this.handleScroll);

	    clearTimeout(this.timelineFill);
	    clearTimeout(this.timelineFinished);
	}

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;
        const isFull = width > 1440;

		let timelineClasses = [
			'timeline',
			this.state.timelineStep
		];

		let maskOnClasses = [
			'mask_on',
			this.state.maskFirst
		];

		var useTag = '<use xlink:href="#icon-circle"></use>';

		const bullets = [];
		for (var i = 0; i < this.state.steps; i++) {
			bullets.push(
				<button key={ i } className={(this.state.step == i) ? 'nav__item nav__item--current' : 'nav__item'} aria-label={'Item ' + i}  onClick={ this.changeTimelineStep.bind(null, i) }>
					<svg className="nav__icon" id="icon-circle" viewBox="0 0 16 16" width="100%" height="100%">
						<circle cx="8" cy="8" r="6.215"></circle>
					</svg>
				</button>
			);
		}

		const cardMensagens = {
			x: (isFull) ? '545' : '545',
			y: (isFull) ? '500' : '500'
		};

		const cardQuemsomos = {
			x: (isFull) ? '1042' : '1042',
			y: (isFull) ? '230' : '250'
		};

		const cardAssociados = {
			x: (isFull) ? '1396' : '1396',
			y: (isFull) ? '85' : '85'
		};

		const cardGovernanca = {
			x: (isFull) ? '2216' : '2216',
			y: (isFull) ? '251' : '251'
		};

		const cardPessoas = {
			x: (isFull) ? '2753' : '2760',
			y: (isFull) ? '475' : '475'
		};

		const cardEstrategia = {
			x: (isFull) ? '3116' : '3140',
			y: (isFull) ? '251' : '263'
		};

		const cardNossoano = {
			x: (isFull) ? '3428' : '3428',
			y: (isFull) ? '132' : '132'
		};

		const cardRelatorio = {
			x: (isFull) ? '4280' : '4275',
			y: (isFull) ? '-80' : '-96'
		};

		const cardSumario = {
			x: (isFull) ? '4705' : '4705',
			y: (isFull) ? '519' : '519'
		};

		const cardCreditos = {
			x: (isFull) ? '5327' : '5334',
			y: (isFull) ? '69' : '79'
		};

		let timelineList = [
			{
				classNames: [
					'timeline--mensagens',
					this.state.timelineItemsDisplayed,
					this.state.navItemActive[0]
				],
				button: {
					x: (isMobile) ? '168' : '545',
					y: (isMobile) ? '32' : '500'
				},
				card: {
					x: (isMobile) ? '168' : cardMensagens.x,
					y: (isMobile) ? '50' : cardMensagens.y
				},
				number: '01',
				title: "Mensagens",
				items: [
					{
						title: 'Mensagens',
						url: '/mensagens'
					}
				]
			},
			{
				classNames: [
					'timeline--quem-somos',
					this.state.timelineItemsDisplayed,
					this.state.navItemActive[1]
				],
				button: {
					x: (isMobile) ? '524' : '1032',
					y: (isMobile) ? '23' : '410'
				},
				card: {
					x: (isMobile) ? '524' : cardQuemsomos.x,
					y: (isMobile) ? '50' : cardQuemsomos.y
				},
				number: '02',
				title: "Quem<br />somos",
				items: [
					{
						title: 'Perfil',
						url: '/quem-somos/perfil'
					},
					{
						title: 'Visão, missão<br />e valores',
						url: '/quem-somos/visao-missao-valores'
					}
				] 
			},
			{
				classNames: [
					'timeline--associados',
					this.state.timelineItemsDisplayed,
					this.state.navItemActive[2]
				],
				button: {
					x: (isMobile) ? '884' : '1396',
					y: (isMobile) ? '50' : '116'
				},
				card: {
					x: (isMobile) ? '884' : cardAssociados.x,
					y: (isMobile) ? '60' : cardAssociados.y
				},
				number: '03',
				title: "Associados",
				items: [
					{
						title: 'Associados',
						url: '/associados'
					}
				] 
			},
			{
				classNames: [
					'timeline--governanca-corporativa',
					this.state.timelineItemsDisplayed,
					this.state.navItemActive[3]
				],
				button: {
					x: (isMobile) ? '1250' : '2216',
					y: (isMobile) ? '34' : '365'
				},
				card: {
					x: (isMobile) ? '1250' : cardGovernanca.x,
					y: (isMobile) ? '55' : cardGovernanca.y
				},
				number: '04',
				title: "Governança<br/>corporativa",
				items: [
					{
						title: 'Assembleia geral',
						url: '/governanca-corporativa/assembleia-geral'
					},
					{
						title: 'Diretoria',
						url: '/governanca-corporativa/diretoria'
					},
					{
						title: 'Conselho Fiscal',
						url: '/governanca-corporativa/conselho-fiscal'
					},
					{
						title: 'Conselho de Ética',
						url: '/governanca-corporativa/conselho-de-etica'
					},
					{
						title: 'Comitê Executivo',
						url: '/governanca-corporativa/comite-executivo'
					},
					{
						title: 'Nossos fóruns',
						url: '/governanca-corporativa/nossos-foruns'
					}
				]
			},
			{
				classNames: [
					'timeline--pessoas',
					this.state.timelineItemsDisplayed,
					this.state.navItemActive[4]
				],
				button: {
					x: (isMobile) ? '1605' : '2748',
					y: (isMobile) ? '5' : '490'
				},
				card: {
					x: (isMobile) ? '1609' : cardPessoas.x,
					y: (isMobile) ? '20' : cardPessoas.y
				},
				number: '05',
				title: "Pessoas",
				items: [
					{
						title: 'Pessoas',
						url: '/pessoas'
					},
					{
						title: 'Perfil',
						url: '/pessoas/perfil'
					},
					{
						title: 'Qualidade de vida',
						url: '/pessoas/qualidade-de-vida'
					},
					{
						title: 'Engajamento',
						url: '/pessoas/engajamento'
					}
				]
			},
			{
				classNames: [
					'timeline--estrategia',
					this.state.timelineItemsDisplayed,
					this.state.navItemActive[5]
				],
				button: {
					x: (isMobile) ? '1965' : '3121',
					y: (isMobile) ? '44' : '337'
				},
				card: {
					x: (isMobile) ? '1962' : cardEstrategia.x,
					y: (isMobile) ? '60' : cardEstrategia.y
				},
				number: '06',
				title: "Estratégia",
				items: [
					{
						title: 'Resultados do plano de ação 2018',
						url: '/estrategia/plano-de-acao'
					},
					{
						title: 'Plano de ação 2019',
						url: '/estrategia/curto-prazo'
					},
					{
						title: 'ANBIMA +5',
						url: '/estrategia/longo-prazo'
					},
					{
						title: 'Relacionamentos',
						url: '/estrategia/relacionamentos'
					}
				]
			},
			{
				classNames: [
					'timeline--nosso-ano',
					this.state.timelineItemsDisplayed,
					this.state.navItemActive[6]
				],
				button: {
					x: (isMobile) ? '2326' : '3428',
					y: (isMobile) ? '17' : '132'
				},
				card: {
					x: (isMobile) ? '2326' : cardNossoano.x,
					y: (isMobile) ? '25' : cardNossoano.y
				},
				number: '07',
				title: "Nosso ano",
				items: [
					{
						title: 'Principais iniciativas',
						url: '/nosso-ano/principais-iniciativas'
					},
					{
						title: 'Eventos',
						url: '/nosso-ano/eventos'
					},
					{
						title: 'Investimentos',
						url: '/nosso-ano/investimentos'
					}
				]
			},
			{
				classNames: [
					'timeline--sobre-relatorio',
					this.state.timelineItemsDisplayed,
					this.state.navItemActive[7]
				],
				button: {
					x: (isMobile) ? '2686' : '4272',
					y: (isMobile) ? '47' : '8'
				},
				card: {
					x: (isMobile) ? '2686' : cardRelatorio.x,
					y: (isMobile) ? '65' : cardRelatorio.y
				},
				number: '08',
				title: "Sobre o<br />relatório",
				items: [
					{
						title: 'Sobre o relatório',
						url: '/sobre-o-relatorio'
					}
				]
			},
			{
				classNames: [
					'timeline--sumario',
					this.state.timelineItemsDisplayed,
					this.state.navItemActive[8]
				],
				button: {
					x: (isMobile) ? '3050' : '4694',
					y: (isMobile) ? '44' : '519'
				},
				card: {
					x: (isMobile) ? '3050' : cardSumario.x,
					y: (isMobile) ? '60' : cardSumario.y
				},
				number: '09',
				title: "Sumário GRI",
				items: [
					{
						title: 'Sumário GRI',
						url: '/sumario-gri'
					}
				]
			},
			{
				classNames: [
					'timeline--creditos',
					this.state.timelineItemsDisplayed,
					this.state.navItemActive[9]
				],
				button: {
					x: (isMobile) ? '3404' : '5318',
					y: (isMobile) ? '34' : '159'
				},
				card: {
					x: (isMobile) ? '3404' : cardCreditos.x,
					y: (isMobile) ? '50' : cardCreditos.y
				},
				number: '10',
				title: "Créditos",
				items: [
					{
						title: 'Créditos',
						url: '/creditos'
					}
				]
			}
		];

		const timelineButtons = [];
		for (let i = 0; i < timelineList.length; i++) {
			// console.log('item ' + i, timelineList[i].items.length);
			if (timelineList[i].items.length > 1) {
				timelineButtons.push(
					<TimelineButton key={ i }
						className={ timelineList[i].classNames.join(' ') }
						x={ timelineList[i].button.x }
						y={ timelineList[i].button.y }
						onClick={ this.setNavItemActive.bind(null, i) } />
				);
			} else {
				timelineButtons.push(
					<TimelineButton key={ i }
						className={ timelineList[i].classNames.join(' ') }
						x={ timelineList[i].button.x }
						y={ timelineList[i].button.y }
						url={ timelineList[i].items[0].url }
						onClick={ this.openTimelinebutton.bind(null, timelineList[i].items[0].url) } />
				);
			}
		}

		const timelineItems = [];
		for (let i = 0; i < timelineList.length; i++) {

			let timelineItemMenu = [];
			for (let u = 0; u < timelineList[i].items.length; u++) {
				timelineItemMenu.push(
					<ListItem key={ u } onClick={ this.runTransition } path={ timelineList[i].items[u].url } text={ timelineList[i].items[u].title }></ListItem>
				);
			}

			timelineItems.push(
	        	<TimelineItem key={ i }
	        		className={ timelineList[i].classNames.join(' ') }
	        		number={ timelineList[i].number }
	        		title={ timelineList[i].title }
	        		x={ timelineList[i].card.x }
	        		y={ timelineList[i].card.y }>
	        		{ timelineItemMenu }
	        	</TimelineItem>
			);
		}

		const animateList = [
			{
				depth: "0.5",
				image: this.images.gray_layer,
				width: (isMobile) ? '57vw' : '47vw',
				x: (isMobile) ? '17vw' : '3vw',
				y: (isMobile) ? '170px' : '30px'
			},
			{
				depth: "0.8",
				image: this.images.green_layer,
				width: (isMobile) ? '70vw' : '20vw',
				x: (isMobile) ? '74vw' : '64vw',
				y: (isMobile) ? '-30px' : '-50px'
			},
			{
				depth: "0.5",
				image: this.images.gray_layer,
				width: (isMobile) ? '41vw' : '19vw',
				x: (isMobile) ? '73vw' : '82vw',
				y: (isMobile) ? '-28px' : '-200px'
			},
			{
				depth: "0.7",
				image: this.images.orange_layer,
				width: (isMobile) ? '58vw' : '20vw',
				x: (isMobile) ? '-98px' : '200px',
				y: (isMobile) ? '39vh' : '62vh'
			},
			{
				depth: "0.5",
				image: this.images.gray_layer,
				width: (isMobile) ? '79vw' : '23vw',
				x: (isMobile) ? '5vw' : '69vw',
				y: (isMobile) ? '76vh' : '50vh'
			},
			{
				depth: "0.9",
				image: this.images.blue_layer,
				width: (isMobile) ? '62vw' : '22vw',
				x: (isMobile) ? '76vw' : '50vw',
				y: (isMobile) ? '54vh' : '79vh'
			}
		];

		const animateLayers = [];
		for (let i = 0; i < animateList.length; i++) {
			animateLayers.push(
				<AnimatedLayer key={ i }
        			depth={ animateList[i].depth }
        			image={ animateList[i].image }
        			width={ animateList[i].width }
        			x={ animateList[i].x }
        			y={ animateList[i].y } />
			);
		}


        return (
    		<Swipeable 
            	className="homepage"
            	ref="homepage"
    			onSwipedLeft={ this.nextItem }
    			onSwipedRight={ this.prevItem }>

				<Helmet>
	                <title>Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

            	<ParallaxScene>
            		{ animateLayers }
            	</ParallaxScene>

            	<div className="home-grand-title">
            		<img src={ this.images.logo } />
            		<div className="title">Relatório<br />Anual 2018</div>
            	</div>

		        <div className={ timelineClasses.join(' ') }>
		        	<div className="timeline__buttons">
			        	{ timelineButtons }
            		</div>

		        	<div className="timeline__images">
	            		<img src={ this.vector_off } id="vectoroff" />
			        	<div className={ maskOnClasses.join(' ') }>
	            			<img src={ this.vector_on } />
	            		</div>
            		</div>

		        	<div className="timeline__items">
		        		{ timelineItems }
	            	</div>
            	</div>

            	<div className="guide-nav">
            		<div className="text">Passe para o lado e conheça mais</div>
            		<div className="bullets nav nav--ayana">
	            		{ bullets }
            		</div>
            	</div>

			</Swipeable>
    	);
	}
}

export { Home };